import { flushSync } from 'react-dom';
import React, { useState, useEffect, useContext } from 'react';
import {FormLayout} from '@shopify/polaris';
import SectionsSelect from './SectionsSelect';
import OrganizationsSelect from './OrganizationsSelect';
import { FormContext } from '@thinkwell/react.common'
import { Spinner, Select } from '@thinkwell/react.polaris'
import { SectionsContext } from './contexts/yolk/Sections'
import { OrganizationsContext } from './contexts/yolk/Organizations'

export default function SectionForm(props) {
  const form = useContext(FormContext)
  const [sections, fetchSections] = useContext(SectionsContext)
  const [organizations, fetchOrganizations] = useContext(OrganizationsContext)
  const formName = props.name || 'section_id'

  useEffect(() => {
    const doFetchOrganizations = async() => {
      const organizations = await fetchOrganizations('/admin/yolk/organizations.json')
      if (organizations && organizations.length) {
        const organizationId = form.field("organization_id")
        if(!organizations.find((org) => org.id == organizationId)) {
          const firstOrganizationId = organizations[0].id
          console.log(`select first org ${firstOrganizationId} ${organizationId ? `(from ${organizationId})` : ''}`)
          flushSync(() => {
            onOrganizationChange(firstOrganizationId)
          })
        } else {
          fetchSectionsForOrg(organizationId)
        }
      }
    }
    doFetchOrganizations()
  }, [])

  const onOrganizationChange = (value) => {
    form.onData("organization_id")(value)
    fetchSectionsForOrg(value)
  }

  const sectionsUrl = (organizationId) => `/admin/yolk/organizations/${organizationId}/sections.json`

  const fetchSectionsForOrg = async(organizationId) => {
    const sections = await fetchSections(sectionsUrl(organizationId))
    const sectionId = form.field(formName)
    if (sections && sections.length && !sections.find((section) => (section.id || section.section_id) == sectionId)) {
      const firstSectionId = sections[0].id || sections[0].section_id
      console.log(`select first section ${firstSectionId} ${sectionId ? `(from ${sectionId})` : ''}`)
      flushSync(() => {
        form.onData(formName)(firstSectionId)
      })
    }
  }

  const onChange = (sectionId) => {
    if(props.onChange) {
      const section = sections.find((section) => section.id == sectionId)
      props.onChange(section)
    }
  }

  return (
    <FormLayout>
      <OrganizationsSelect required={props.required}
        onChange={onOrganizationChange}
      />
      <SectionsSelect
          required={props.required}
          name={props.name}
          onChange={onChange}
          notFoundMessage={props.sectionsNotFoundMessage}
      />
    </FormLayout>
  );
}
